import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: theme.spacing(88.5),
  width: '100%',
}));
export default StyledBox;
